import React from 'react';
import { connect } from 'react-redux';
import history from '../../helpers/history';
import { Alert } from 'reactstrap';
import getPricingPageUrl from './PricingPageUrl';
import * as actions from '../../actions';
import { getTranslationKey } from '../../modules/utils/helpers';

interface DiscountKey {
  _id: string;
  first_fixed?: number;
  first_percent?: number;
  free_months?: number;
  noMinimumContractLength?: boolean;
}

interface Digistore {
  discountKey?: DiscountKey;
}

interface DiscountAlertProps {
  digistore?: Digistore;
  className?: string;
  userType: string;
  logUserActivity: (data: { action: string; logAsHubpostNote: boolean; leadScore: number }) => void;
  utm_medium?: string;
  utm_campaign?: string;
  utm_source?: string;
  afterClick?: () => void;
  isOpen?: boolean;
  closeDiscountAlert?: () => void;
}

const DiscountAlert: React.FC<DiscountAlertProps> = ({
  digistore,
  className,
  userType,
  logUserActivity,
  utm_medium,
  utm_campaign,
  utm_source,
  afterClick,
  isOpen,
  closeDiscountAlert
}) => {
  if (digistore && digistore.discountKey && digistore.discountKey._id) {
    let type = '';
    let text = '';
    const value = digistore.discountKey.first_fixed || digistore.discountKey.first_percent;

    if (digistore.discountKey.free_months) {
      type = 'freeMonths';
      text = getTranslationKey('freeMonthsActive').replace(
        '$$free_months$$',
        String(digistore.discountKey.free_months)
      );
    } else {
      if (digistore.discountKey.first_fixed) {
        type = '€';
      } else {
        type = '%';
      }

      text = getTranslationKey('discountKeyActive')
        .replace('$$value$$', String(value))
        .replace('$$type$$', type)
        .replace(
          '$$noMinimumContractLength$$',
          digistore.discountKey.noMinimumContractLength
            ? ` ${getTranslationKey('noMinimumContractLength')}`
            : ''
        );
    }

    return (
      <Alert
        id="discount-key-alert"
        className={className || 'cursor-pointer'}
        isOpen={isOpen}
        toggle={closeDiscountAlert}
        onClick={({ target }: React.MouseEvent<HTMLDivElement>) => {
          const targetElement = target as HTMLElement;
          if (targetElement.className) {
            if (userType === 'SB') {
              logUserActivity({
                action: 'CLICK_DISCOUNT_KEY',
                logAsHubpostNote: true,
                leadScore: 8
              });

              window.location.href = getPricingPageUrl(digistore, {
                utm_medium: utm_medium || 'discount-alert',
                utm_campaign: utm_campaign || 'builder-discounts',
                utm_source: utm_source || 'builder'
              });
              afterClick && afterClick();
            } else {
              history.push('/subscription/pricing');
            }
          }
        }}
        color="primary"
      >
        {text}
      </Alert>
    );
  }

  return null;
};

interface RootState {
  auth: {
    digistore?: Digistore;
    type: string;
  };
}

function mapStateToProps({ auth: { digistore, type } }: RootState) {
  return { digistore, userType: type };
}

export default connect(mapStateToProps, actions)(DiscountAlert);
